export default "__VITE_ASSET__CamyI7ta__"